import { LanguageProviderContext } from "@/providers/LanguageProvider";
import React, { useContext } from "react";

export default function AccessDenied() {
  const { translator } = useContext(LanguageProviderContext);
  return (
    <div className="h-64 flex items-center justify-center flex-col">
      <h3 className="text-xl font-semibold text-foreground mb-2">
        {translator("Home.restrictedAccess")}
      </h3>
      <p className="text-muted-foreground">
        {translator("Home.noPermissionsToAccess")}
      </p>
    </div>
  );
}
